<div class="ts-wrap">
  <span class="ts-label">Tema</span>

  <div class="ts-pills">
    @for (t of themes; track t.id) {
      <button
        class="ts-pill"
        [class.ts-pill--active]="t.id === active.id"
        (click)="select(t)"
        [title]="t.name">

        <!-- Muestra los 2 colores principales del tema -->
        <span class="ts-pill__swatch">
          <span class="ts-pill__c1" [style.background]="t.cardBg"></span>
          <span class="ts-pill__c2" [style.background]="t.accent"></span>
        </span>

        <span class="ts-pill__name">{{ t.name }}</span>

        @if (t.id === active.id) {
          <span class="ts-pill__check">✓</span>
        }
      </button>
    }
  </div>
</div>
